module.exports = __webpack_public_path__ + "img/produkt-repa-varena.960c6a20.jpg";